<script setup>
import moment from "moment";
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="flex items-center mb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            Dokumen Pra-Presentasi PJP Baru
          </div>
          <div
            class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
            style="min-height: 60vh"
          >
            <div class="row">
              <div
                class="col-md-6 d-flex justify-content-start"
                style="padding-left: 2rem; padding-top: 0.5rem"
              >
                <img
                  src="../../assets/images/borneo-indobara-icon.png"
                  alt=""
                  style="width: 15%; height: auto"
                />
              </div>
              <div
                class="col-md-6 d-flex justify-content-end"
                style="padding-right: 2rem; padding-top: 0.5rem"
              >
                <p class="fs-5 fw-bold" style="">BIB-HSE-PPO-F-096-06</p>
              </div>
            </div>
            <div class="container p-4">
              <h1 class="text-center mb-3 font-inter font-bold text-3xl">
                SURAT PERNYATAAN KEBENARAN DOKUMEN
              </h1>
              <p
                class="text-center fs-8 mb-3"
                style="font-family: 'Inter-Regular'"
              >
                Formulir ini digunakan untuk membuat pernyataan kebenaran
                dokumen yang dilampirkan oleh perusahaan jasa/mitra kerja di PT
                Borneo Indobara
              </p>
              <!-- form di sini -->
              <form action="#" @submit.prevent="preventSubmit">
                <!-- <div class="row mb-1">
                        <div class="col-md-12">
                            <p class="text-danger fst-italic fs-8 fw-bold">
                                * Wajib diisi
                            </p>
                        </div>
                    </div> -->
                <div class="row mb-2">
                  <div class="col-md-3">&nbsp;</div>
                  <div class="col-md-6">
                    <p for="nomor" class="form-label text-center fs-8 fw-bold">
                      Nomor <span class="text-danger fs-6">*</span>
                    </p>
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="nomor"
                      placeholder="Masukkan Nomor Anda"
                      v-model="formValues.nomor"
                      :disabled="statusSio != 0 && statusSio != -3"
                    />
                  </div>
                  <div class="col-md-3">&nbsp;</div>
                </div>
                <p class="mb-2 fs-8">Yang bertanda tangan di bawah ini:</p>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="nama" class="form-label fs-8 fw-bold"
                      >Nama Pimpinan Tertinggi Perusahaan<span
                        class="text-danger fs-6"
                        >*</span
                      ></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="nama"
                      placeholder="Masukkan Nama Lengkap Pimpinan Tertinggi Perusahaan"
                      v-model="formValues.namaPimpinan"
                      :disabled="
                        (statusSio != 0 && statusSio != -3) ||
                        formValues.namaPimpinan != null
                      "
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="perusahaan" class="form-label fs-8 fw-bold"
                      >Perusahaan</label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="perusahaan"
                      placeholder="Masukkan PT/CV"
                      v-model="formValues.perusahaan"
                      disabled
                    />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-6">
                    <label for="jabatan" class="form-label fs-8 fw-bold"
                      >Jabatan Pimpinan Tertinggi Perusahaan<span
                        class="text-danger fs-6"
                        >*</span
                      ></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="jabatan"
                      placeholder="Masukkan Nama Jabatan Pimpinan Tertinggi Perusahaan"
                      v-model="formValues.jabatanPimpinan"
                      :disabled="
                        (statusSio != 0 && statusSio != -3) ||
                        formValues.jabatanPimpinan != null
                      "
                    />
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="nama" class="form-label fs-8 fw-bold"
                      >Nama Calon PJO<span class="text-danger fs-6"
                        >*</span
                      ></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="nama"
                      placeholder="Masukkan Nama Lengkap Calon PJO"
                      v-model="formValues.namaPjo"
                      :disabled="
                        (statusSio != 0 && statusSio != -3) ||
                        formValues.namaPjo != null
                      "
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="perusahaan" class="form-label fs-8 fw-bold"
                      >Perusahaan</label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="perusahaan"
                      placeholder="Masukkan PT/CV"
                      v-model="formValues.perusahaan"
                      disabled
                    />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-6">
                    <label for="jabatan" class="form-label fs-8 fw-bold"
                      >Jabatan Calon PJO<span class="text-danger fs-6"
                        >*</span
                      ></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="jabatan"
                      placeholder="Masukkan Nama Jabatan Struktural Calon PJO"
                      v-model="formValues.jabatanPjo"
                      :disabled="
                        (statusSio != 0 && statusSio != -3) ||
                        formValues.jabatanPjo != null
                      "
                    />
                  </div>
                </div>
                <p class="mb-1 fs-8" style="font-family: 'Inter-Regular'">
                  MENYATAKAN:
                </p>
                <p class="mb-1 fs-8" style="font-family: 'Inter-Regular'">
                  Bahwa semua dokumen yang dilampirkan untuk persyaratan
                  Pengesahan Penanggung Jawab Operasional (PJO)
                </p>
                <div class="row mb-3">
                  <div class="col-md-6">
                    <label for="perusahaan" class="form-label fs-8 fw-bold"
                      >Perusahaan</label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="perusahaan"
                      placeholder="Masukkan PT/CV"
                      v-model="formValues.perusahaan"
                      disabled
                    />
                  </div>
                </div>
                <p class="mb-3 fs-8" style="font-family: 'Inter-Regular'">
                  adalah BENAR.<br />
                  Apabila di kemudian hari diketahui dokumen yang dilampirkan
                  adalah PALSU/TIDAK BENAR maka kami siap mempertanggungjawabkan
                  secara hukum.<br />
                  Demikian Surat Pernyataan ini kami buat untuk dipergunakan
                  sebagaimana mestinya.
                </p>
                <div class="row mb-3">
                  <div class="col-md-3">
                    <label for="tempat" class="form-label fs-8 fw-bold"
                      >Tempat <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="tempat"
                      placeholder="Masukkan Tempat"
                      v-model="formValues.tempat"
                      :disabled="statusSio != 0 && statusSio != -3"
                    />
                  </div>
                  <div class="col-md-3">
                    <label for="tanggal" class="form-label fs-8 fw-bold"
                      >Tanggal <span class="text-danger fs-6">*</span></label
                    >
                    <datepicker
                      v-model="formValues.tanggal"
                      value=""
                      name="tanggal"
                      placeholder="Pilih Tanggal"
                      class="form-control fs-9"
                      input-class="fw-bold"
                      format="yyyy-MM-dd"
                      :disabled="statusSio != 0 && statusSio != -3"
                    ></datepicker>
                  </div>
                </div>
                <p class="mb-3 fs-8" style="font-family: 'Inter-Regular'">
                  Yang Membuat Pernyataan,
                </p>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="tandaTangan" class="form-label fs-8 fw-bold">
                      Tanda Tangan (png, jpg, jpeg)
                      <span class="text-danger fs-6">*</span>
                    </label>
                    <div v-if="fileTtd != ''" class="fs-8">
                      <img :src="fileTtd" style="height: 5rem" />
                    </div>
                    <!-- <Vue3Signature  ref="signature1" :sigOption="state.option" :w="'100%'" :h="'85%'"
                                :disabled="state.disabled" class="example border"></Vue3Signature> -->
                    <div
                      class="input-group mb-1"
                      :hidden="
                        (statusSio != 0 && statusSio != -3) || fileTtd != ''
                      "
                    >
                      <input
                        type="file"
                        ref="tandaTangan"
                        accept="image/png, image/jpg, image/jpeg"
                        class="form-control fs-9"
                        id="inputGroupFile04"
                        @change="handleChangeFile('tandaTangan')"
                        aria-describedby="inputGroupFileAddon04"
                        aria-label="Upload"
                      />
                      <button
                        class="btn btn-outline-secondary fs-9 border border-start-0"
                        type="button"
                        id="inputGroupFileAddon04"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-cloud-arrow-up"
                          style="color: #000000"
                        />
                      </button>
                    </div>
                    <div
                      v-if="validasiFile.sizeTtd"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ukuran file melebihi batas (Max: {{ max_file_size }}MB)
                    </div>
                    <div
                      v-if="validasiFile.typeTtd"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ekstensi file tidak sesuai, Mohon tambahkan file Gambar
                      png, jpg, jpeg
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for="tandaTangan" class="form-label fs-8 fw-bold">
                      Tanda Tangan (png, jpg, jpeg)
                      <span class="text-danger fs-6">*</span>
                    </label>
                    <div v-if="fileTtd2 != ''" class="fs-8">
                      <img :src="fileTtd2" style="height: 5rem" />
                    </div>
                    <!-- <Vue3Signature  ref="signature1" :sigOption="state.option" :w="'100%'" :h="'85%'"
                                :disabled="state.disabled" class="example border"></Vue3Signature> -->
                    <div
                      class="input-group mb-1"
                      :hidden="
                        (statusSio != 0 && statusSio != -3) || fileTtd2 != ''
                      "
                    >
                      <input
                        type="file"
                        ref="tandaTangan2"
                        accept="image/png, image/jpg, image/jpeg"
                        class="form-control fs-9"
                        id="inputGroupFile04"
                        @change="handleChangeFile('tandaTangan2')"
                        aria-describedby="inputGroupFileAddon04"
                        aria-label="Upload"
                      />
                      <button
                        class="btn btn-outline-secondary fs-9 border border-start-0"
                        type="button"
                        id="inputGroupFileAddon04"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-cloud-arrow-up"
                          style="color: #000000"
                        />
                      </button>
                    </div>
                    <div
                      v-if="validasiFile.sizeTtd2"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ukuran file melebihi batas (Max: {{ max_file_size }}MB)
                    </div>
                    <div
                      v-if="validasiFile.typeTtd2"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ekstensi file tidak sesuai, Mohon tambahkan file Gambar
                      png, jpg, jpeg
                    </div>
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="namaPimpinan" class="form-label fs-8 fw-bold"
                      >Nama Lengkap
                      <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="namaPimpinan"
                      placeholder="Masukkan Nama Lengkap"
                      v-model="formValues.namaTTD"
                      :disabled="
                        (statusSio != 0 && statusSio != -3) ||
                        formValues.namaTTD != null
                      "
                    />
                    <label class="form-label fs-8 fw-bold"
                      >Pimpinan Tertinggi Perusahaan</label
                    >
                  </div>
                  <div class="col-md-6">
                    <label for="namaCalonPjo" class="form-label fs-8 fw-bold"
                      >Nama Lengkap
                      <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9 mb-1"
                      id="namaCalonPjo"
                      placeholder="Masukkan Nama Lengkap PJO"
                      v-model="formValues.namaTTD2"
                      :disabled="
                        (statusSio != 0 && statusSio != -3) ||
                        formValues.namaTTD2 != null
                      "
                    />
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="jabatanPjo"
                      placeholder="Masukkan Jabatan PJO"
                      v-model="formValues.jabatanPjo"
                      disabled
                    />
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-md-6">
                    <p class="text-danger fst-italic fs-8 fw-bold mb-1">
                      * Wajib diisi
                    </p>
                  </div>
                  <div
                    class="col-md-6 d-flex justify-content-end align-items-end"
                  >
                    <button
                      type="button"
                      @click="clickSimpan()"
                      class="btn btn_cari w-50"
                      style="height: 2.5rem"
                      :hidden="statusSio != 0 && statusSio != -3"
                      :disabled="disabled"
                    >
                      {{
                        statusSio == 0
                          ? "Submit"
                          : statusSio == -3
                          ? "Submit Ulang"
                          : "Submit"
                      }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>
<style>
section .vuejs3-datepicker__calendar-topbar {
  min-height: auto;
}

.vuejs3-datepicker__value {
  font-size: 0.7rem !important;
  border: 0px !important;
  padding: 0px !important;
}
.vuejs3-datepicker__icon svg {
  height: 0.8rem;
}

.vuejs3-datepicker__content {
  font-size: 0.8rem !important;
  margin-left: 0.3rem !important;
  margin-bottom: -1rem !important;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Semi-transparent white overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Make sure it's above other elements on the page */
}

.loading-spinner {
  /* Add your loading spinner styles here */
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  /* animation: spin 1s linear infinite; */
}

/* @keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
} */
</style>

<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue"
import GlobalDataMixin from "../../GlobalDataMixin";
import Datepicker from "vuejs3-datepicker";

import axios from "axios";
import Swal from "sweetalert2";

import {
  API_BASE_URL,
  // CMS_UPLOAD,
  CMS_SIO_SET_KEBENARAN_DOKUMEN,
  CMS_SIO_GET_KEBENARAN_DOKUMEN,
  CMS_DOWNLOAD,
  CMS_UPLOAD_USECASE,
  CMS_GET_KELENGKAPAN_SIO,
  CMS_SIO_GET_DASHBOARD,
  CMS_VIEW_IMAGE,
  CMS_GET_SIOID,
} from "../../constants.js";

const url_simpan = API_BASE_URL + CMS_SIO_SET_KEBENARAN_DOKUMEN;
// const url_upload = API_BASE_URL + CMS_UPLOAD
const url_upload_usecase = API_BASE_URL + CMS_UPLOAD_USECASE;
const url_get_kebenarandokumen = API_BASE_URL + CMS_SIO_GET_KEBENARAN_DOKUMEN;
const url_get_siodashboard = API_BASE_URL + CMS_SIO_GET_DASHBOARD;
const url_get_sioid = API_BASE_URL + CMS_GET_SIOID;
const url_get_kelengkapan = API_BASE_URL + CMS_GET_KELENGKAPAN_SIO;

const url_download = API_BASE_URL + CMS_DOWNLOAD;
const max_file_size = 5; // MB

import { reactive, ref } from "vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

const state = reactive({
  count: 0,
  option: {
    penColor: "rgb(0, 0, 0)",
    backgroundColor: "rgb(255,255,255)",
  },
  disabled: false,
});

const signature1 = ref(null);

export default {
  mixins: [GlobalDataMixin],
  name: "FormSuratPermohonanPengesahanPJO",
  components: { DefaultLayout, Datepicker },
  data() {
    return {
      isLoading: false,
      sioID: null,
      idKelengkapan: null,
      refIDForm: 4,
      idForm: null,
      formValues: {
        nomor: "",
        namaPimpinan: "",
        jabatanPimpinan: "",
        namaPjo: "",
        jabatanPjo: "",
        perusahaan: "",
        tempat: "",
        tanggal: moment(new Date()).format("YYYY-MM-DD"),
        tandaTangan: "",
        namaTTD: "",
        tandaTangan2: "",
        namaTTD2: "",
      },
      url_icon: "",
      fileTtd: "",
      fileTtd2: "",
      // fileAttachment:'',
      validasiFile: {
        typeTtd: false,
        sizeTtd: false,
        typeTtd2: false,
        sizeTtd2: false,
        typeAtt: false,
        sizeAtt: false,
      },
      statusSio: 0,
      kontraktorID: null,
      disabled: false
    };
  },
  mounted() {
    this.kontraktorID = parseInt(this.userData.kontraktorID);
    if (localStorage.getItem("sio_cms") != null) {
      this.sioID = JSON.parse(localStorage.getItem("sio_cms")).id;
      this.getSioDashboard(this.sioID);
      this.getSioID(this.kontraktorID);
      this.getKelengkapan(this.sioID);
    }

    if (localStorage.getItem("icon_kontraktor_cms") != null) {
      this.url_icon =
        API_BASE_URL +
        CMS_VIEW_IMAGE +
        JSON.parse(localStorage.getItem("icon_kontraktor_cms")).icon;
    }
    this.formValues.perusahaan =
      this.userData.kontraktorName != null
        ? this.userData.kontraktorName
        : null;
  },
  methods: {
    preventSubmit() {
      console.log("prevent submit");
    },
    getSioDashboard(sio_id) {
      axios
        .get(url_get_siodashboard + sio_id, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log(response);
          let ret_dash = response.data.data;
          if (ret_dash.length > 0) {
            for (let i = 0; i < ret_dash.length; i++) {
              if (ret_dash[i].idForm == this.refIDForm) {
                this.idForm = ret_dash[i].id;
                this.getKebenaranDokumen(ret_dash[i].id);
              }
            }
          }
          // this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioDashboard : " + error.message);
          console.error("Error fetching data getSioDashboard :", error.message);
        });
    },
    getKebenaranDokumen(idform) {
      axios
        .get(url_get_kebenarandokumen + idform, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("getKebenaranDokumen", response);
          let dt = response.data.data;

          if (dt != null) {
            this.formValues.nomor =
              dt.nomorKontraktor == null ? "" : dt.nomorKontraktor;
            // this.formValues.namaPimpinan = dt.namaPemimpin==null?'':dt.namaPemimpin;
            // this.formValues.jabatanPimpinan = dt.jabatanPemimpin==null?'':dt.jabatanPemimpin;
            this.formValues.tempat = dt.tempat == null ? "" : dt.tempat;
            this.formValues.tanggal =
              dt.tanggalTtd != null
                ? moment(dt.tanggalTtd).format("YYYY-MM-DD")
                : null;

            /*if(dt.tandaTanganPemimpin!=''&&dt.tandaTanganPemimpin!=null){
                this.fileTtd = API_BASE_URL + CMS_VIEW_IMAGE + dt.tandaTanganPemimpin;
              }
              
              if(dt.tandaTangan!=''&&dt.tandaTangan!=null){
                this.fileTtd2 = API_BASE_URL + CMS_VIEW_IMAGE + dt.tandaTangan;
              }*/

            // if(dt.attachmentFile!=''&&dt.attachmentFile!=null){
            //                     this.fileAttachment = dt.attachmentFile;
            //                   }

            // this.formValues.namaTTD = dt.namaPengesahPemimpin==null?'':dt.namaPengesahPemimpin;
            // this.formValues.namaTTD2 = dt.namaPengesah==null?'':dt.namaPengesah;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getKebenaranDokumen : " + error.message);
          console.error(
            "Error fetching data getKebenaranDokumen :",
            error.message
          );
        });
    },
    async simpanForm() {
      this.disabled = true
      const tandaTangan = this.$refs.tandaTangan.files[0];
      const tandaTangan2 = this.$refs.tandaTangan2.files[0];
      // const fileAttachment = this.$refs.fileAttachment.files[0];

      var purs = [];
      var files = [];
      if (tandaTangan != null) {
        purs.push("form4");
        files.push(tandaTangan);
      }

      if (tandaTangan2 != null) {
        purs.push("pimpinan");
        files.push(tandaTangan2);
      }

      // if(fileAttachment!=null){
      //   purs.push('attachment');
      //   files.push(fileAttachment);
      // }
      // this.formValues.ttd = tandaTangan;
      let bodyJsonProfile = {};
      if (this.idForm != null) {
        bodyJsonProfile = {
          id: this.idForm,
          idSio: this.sioID,
          // "kontraktorId": this.userData.kontraktorID,
          nomorKontraktor: this.formValues.nomor,
          namaPemimpin: this.formValues.nama,
          jabatanPemimpin: this.formValues.jabatan,
          tempat: this.formValues.tempat,
          tanggalTtd:
            this.formValues.tanggal != null && this.formValues.tanggal != ""
              ? moment(this.formValues.tanggal).format("YYYY-MM-DD")
              : null,
          tandaTanganPemimpin: null,
          namaPengesahPemimpin: this.formValues.namaTTD,
          tandaTangan: null,
          namaPengesah: this.formValues.namaTTD2,
          // "reason":'',
        };
      } else {
        bodyJsonProfile = {
          // "id": 0,
          idSio: this.sioID,
          // "kontraktorId": this.userData.kontraktorID,
          nomorKontraktor: this.formValues.nomor,
          namaPemimpin: this.formValues.nama,
          jabatanPemimpin: this.formValues.jabatan,
          tempat: this.formValues.tempat,
          tanggalTtd:
            this.formValues.tanggal != null && this.formValues.tanggal != ""
              ? moment(this.formValues.tanggal).format("YYYY-MM-DD")
              : null,
          tandaTanganPemimpin: null,
          namaPengesahPemimpin: this.formValues.namaTTD,
          tandaTangan: null,
          namaPengesah: this.formValues.namaTTD2,
          reason: "",
        };
      }

      await axios
        .post(url_simpan, bodyJsonProfile, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response simpanForm : ", response);

          let idForm = response.data.data.id;

          if (files.length > 0 && purs.length > 0) {
            this.uploadFiles(files, purs, idForm);
          } else {
            this.alertSukses();
          }
        })
        .catch((error) => {
          console.log("error simpanForm : ", error);
          alert("error simpanForm");
          // if(error.response.status==500){
          //     alert("Error "+error.response.status+" simpanAddSubKontraktor : " + error.response.data.status.message)
          // }else if(error.response.status==400){
          //     alert("Error "+error.response.status+" simpanAddSubKontraktor : " + error.response.data.status.message)
          // }else if(error.response.status==401){
          //     alert("Error "+error.response.status+" simpanAddSubKontraktor : " + error.response.data.status.message)
          // }
        })
        .then(() => {});
    },

    async uploadFiles(files, purs, idForm) {
      for (var x in files) {
        // console.log(files[x])
        // console.log(purs[x])
        let file = files[x];
        let pur = purs[x];
        if (file) {
          // Get the file name
          const fileName = file.name;

          // Create a FormData object and append the file
          const formData = new FormData();
          formData.append("file", file);
          formData.append("id", idForm);
          formData.append("purpose", pur);
          formData.append("usecase", "ttd_form4");

          // Make the API request to upload the file
          try {
            const response = await axios.post(url_upload_usecase, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                role: this.userData.role,
                Authorization: "Bearer " + this.userData.token,
                accept: "*/*",
              },
            });

            // Handle the response from the server as needed
            console.log("File upload response:", response.data);
            console.log("filename : ", fileName);
          } catch (error) {
            // Handle errors, e.g., display an error message to the user
            alert(error.message);
            if (error.response.data != null) {
              alert(error.response.data.message);
            }
            this.isLoading = false;
            console.error("Error uploading file:", error);
            // this.$router.go(this.$router.currentRoute)
          }
        }
      }
      this.alertSukses();
    },
    clickSimpan() {
      this.isLoading = true;
      if (this.validasiForm()) {
        this.simpanForm();
      } else {
        alert("Lengkapi pengisian form !");
        this.isLoading = false;
      }
    },
    validasiForm() {
      if (
        this.formValues.nomor.trim() != "" &&
        this.formValues.nama != "" &&
        this.formValues.jabatan != "" &&
        this.formValues.tempat.trim() != "" &&
        this.formValues.tanggal != "" &&
        this.formValues.namaTTD != "" &&
        this.formValues.namaTTD2 != "" &&
        (this.fileTtd != "" || this.$refs.tandaTangan.value != "") &&
        (this.fileTtd2 != "" || this.$refs.tandaTangan2.value != "")
        // &&(this.fileAttachment!=""||this.$refs.fileAttachment.value!="")
      ) {
        return true;
      } else {
        return false;
      }
    },
    save(t) {
      console.log(signature1.value.save(t));
      console.log(signature1);
      console.log(signature1.value);
      state.disabled = true;
    },

    clear() {
      signature1.value.clear();
      state.disabled = false;
    },

    undo() {
      signature1.value.undo();
      state.disabled = false;
    },

    alertSukses() {
      Swal.fire({
        title: "Simpan Form Sukses",
        text: "Surat Pernyataan Kebenaran Dokumen Berhasil disimpan !",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        this.$router.back();
      });
    },
    handleChangeFile(refFile) {
      let file = null;

      if (refFile == "tandaTangan") {
        file = this.$refs.tandaTangan.files[0];
        if (file) {
          // Check file type
          if (
            file.type !== "image/jpg" &&
            file.type !== "image/jpeg" &&
            file.type !== "image/png"
          ) {
            this.validasiFile.typeTtd = true;
            this.validasiFile.sizeTtd = false;
            this.$refs.tandaTangan.value = "";
            return;
          }

          // Check file size ({{max_file_size}}MB limit)
          if (file.size > max_file_size * 1024 * 1024) {
            this.validasiFile.typeTtd = false;
            this.validasiFile.sizeTtd = true;
            this.$refs.tandaTangan.value = "";
            return;
          }

          // Reset error messages if the file is valid
          this.validasiFile.typeTtd = false;
          this.validasiFile.sizeTtd = false;

          // Handle the valid file as needed (e.g., store the file)
          console.log("Valid file:", file);
        }
      } else if (refFile == "tandaTangan2") {
        file = this.$refs.tandaTangan2.files[0];
        if (file) {
          // Check file type
          if (
            file.type !== "image/jpg" &&
            file.type !== "image/jpeg" &&
            file.type !== "image/png"
          ) {
            this.validasiFile.typeTtd2 = true;
            this.validasiFile.sizeTtd2 = false;
            this.$refs.tandaTangan2.value = "";
            return;
          }

          // Check file size ({{max_file_size}}MB limit)
          if (file.size > max_file_size * 1024 * 1024) {
            this.validasiFile.typeTtd2 = false;
            this.validasiFile.sizeTtd2 = true;
            this.$refs.tandaTangan2.value = "";
            return;
          }

          // Reset error messages if the file is valid
          this.validasiFile.typeTtd2 = false;
          this.validasiFile.sizeTtd2 = false;

          // Handle the valid file as needed (e.g., store the file)
          console.log("Valid file:", file);
        }
      }
      // else if(refFile=='fileAttachment'){
      //   file = this.$refs.fileAttachment.files[0];
      //   if (file) {
      //     // Check file type
      //     if (file.type !== "application/pdf") {
      //       this.validasiFile.typeTtd2 = true
      //       this.validasiFile.sizeTtd2 = false
      //       this.$refs.tandaTangan2.value = ""
      //       return
      //     }

      //     // Check file size ({{max_file_size}}MB limit)
      //     if (file.size > max_file_size * 1024 * 1024) {
      //       this.validasiFile.typeTtd2 = false
      //       this.validasiFile.sizeTtd2 = true
      //       this.$refs.tandaTangan2.value = ""
      //       return
      //     }

      //     // Reset error messages if the file is valid
      //     this.validasiFile.typeTtd2 = false
      //     this.validasiFile.sizeTtd2 = false

      //     // Handle the valid file as needed (e.g., store the file)
      //     console.log('Valid file:', file);
      //   }
      // }
    },

    downloadFile(filename) {
      axios
        .get(url_download + filename, { responseType: "blob" })
        .then((response) => {
          this.handleFileDownload(response.data, filename);
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
        });
    },
    handleFileDownload(blobData, filename) {
      var dateNow = moment(new Date()).format("DDMMYYYY");
      // Create a Blob from the response data
      const blob = new Blob([blobData], { type: "application/octet-stream" });
      console.log(filename);
      // Create a link element and trigger a download
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Surat_Pernyataan_Kebenaran_Dokumen_" + dateNow + ".pdf"; // Set the desired file name
      link.click();
    },
    getSioID(id) {
      axios
        .get(url_get_sioid + id, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          this.statusSio = response.data.data.status;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioID : " + error.message);
          console.error("Error fetching data getSioID :", error.message);
        });
    },
    getKelengkapan(sio_id) {
      axios
        .get(url_get_kelengkapan + sio_id, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log(response);
          // this.kontraktor = response.data.detailKontraktor
          // // set value form edit
          // this.formValues.namaKontraktor = this.kontraktor.namaKontraktor
          let ret_kel = response.data;
          this.idKelengkapan = ret_kel.id == null ? "" : ret_kel.id;
          this.formValues.namaPimpinan =
            ret_kel.namaAtasan == null ? "" : ret_kel.namaAtasan;
          this.formValues.jabatanPimpinan =
            ret_kel.jabatanAtasan == null ? "" : ret_kel.jabatanAtasan;
          this.formValues.namaPjo =
            ret_kel.namaPjo == null ? "" : ret_kel.namaPjo;
          this.formValues.jabatanPjo =
            ret_kel.jabatanPjo == null ? "" : ret_kel.jabatanPjo;
          this.formValues.namaTTD =
            ret_kel.namaAtasan == null ? "" : ret_kel.namaAtasan;
          this.formValues.namaTTD2 =
            ret_kel.namaPjo == null ? "" : ret_kel.namaPjo;

          if (ret_kel.ttdAtasan != "" && ret_kel.ttdAtasan != null) {
            this.fileTtd = API_BASE_URL + CMS_VIEW_IMAGE + ret_kel.ttdAtasan;
          }

          if (ret_kel.ttdPjo != "" && ret_kel.ttdPjo != null) {
            this.fileTtd2 = API_BASE_URL + CMS_VIEW_IMAGE + ret_kel.ttdPjo;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getKelengkapan : " + error.message);
          console.error("Error fetching data getKelengkapan :", error.message);
        });
    },
  },
};
</script>
